import React from "react";

import Grid from "@material-ui/core/Grid";
import { useFormikContext } from "formik";
import styled from "styled-components/macro";

import { Input, PercentageInput, withNamespace } from ".";
import { CheckBox } from "./CheckBox";
import { HelpText } from "./HelpText";
import { Label } from "./Label";

const CheckboxGrid = styled(Grid)`
  align-self: flex-end;
  text-align: start;
`;

const AgencyCheckbox = () => {
  return (
    <CheckBox
      label="Enable Interest"
      name={withNamespace("billingSettings", "enableInterest")}
      dataTour="enableInterest"
    />
  );
};

const BusinessCheckbox = ({ ns }) => {
  return (
    <CheckBox
      name={withNamespace(ns, "overrideInterestSettings")}
      label="Override Interest settings from my Agency settings"
    />
  );
};

export function InterestSettingForm(props) {
  const {
    namespace = "",
    name = "interestSettings",
    label = null,
    tooltip,
    useBusinessCheckbox = false,
  } = props;

  const { values } = useFormikContext();
  const { overrideInterestSettings, billingSettings = {} } = values;

  const { enableInterest } = billingSettings;

  const showInterestForm = useBusinessCheckbox
    ? overrideInterestSettings
    : enableInterest;

  return (
    <Grid data-tour="interest" container spacing={2} item xs={12}>
      <Grid item xs={12}>
        {label ? <Label tooltip={tooltip}>{label}</Label> : null}
      </Grid>
      <Grid item xs={12}>
        {useBusinessCheckbox ? (
          <BusinessCheckbox ns={namespace} />
        ) : (
          <AgencyCheckbox />
        )}
      </Grid>
      {showInterestForm && (
        <>
          <Grid item xs={6}>
            <PercentageInput
              name={`${withNamespace(namespace, name)}.0.debitInterestRate`}
              label="Debit Interest Rate"
              tooltip="Debit interest rate are applied to Invoice Doucments that are deemed to be overdue and are suggested to be charged interest"
            />
          </Grid>
          <Grid item xs={6}>
            <PercentageInput
              name={`${withNamespace(namespace, name)}.0.creditInterestRate`}
              label="Credit Interest Rate"
              tooltip="Credit interest rate are applied to RCTI Doucments that are deemed to be overdue and are suggested to be charged interest"
            />
          </Grid>
          <Grid item xs={6}>
            <Input
              name={`${withNamespace(namespace, name)}.0.daysOverdueThreshold`}
              label="Days Overdue Threshold"
              type="number"
              afterSymbol="days"
              tooltip="A threshold of days overdue from which time interest charges are suggested"
            />
          </Grid>
          {!useBusinessCheckbox && (
            <CheckboxGrid item xs={6}>
              <CheckBox
                label="Compound?"
                name={withNamespace(
                  "billingSettings",
                  "enableCompoundInterest",
                )}
                tooltip="Include overdue interest charges with the original overdue amount when calculating interest"
              />
            </CheckboxGrid>
          )}
          <Grid item xs={12}>
            <HelpText>
              Applies to transactions that are past a threshold of days overdue
              and suggests chargeable interest from the due date at a daily rate
              charged monthly.
            </HelpText>
          </Grid>
        </>
      )}
    </Grid>
  );
}
